export default __webpack_public_path__ + "static/media/sauna.f17dde50.JPG";